import styled from 'styled-components';
import { Parallax } from 'react-scroll-parallax';
import { themeGet } from 'styled-system';

export const Wrap = styled.figure`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding: 2rem 5%;

  img {
    min-width: 75%;
    width: calc(100% - 150px);
    height: 90vh;
    object-fit: contain;
  }
`;

export const Context = styled(Parallax)`
  width: 240px;
  position: absolute;
  bottom: 2rem;
  right: 5%;

  .inner {
    width: 100%;
    height: 100%;
    border: 5px solid ${themeGet('color.4')};
    padding: 1rem;
  }

  dl {
    margin-bottom: 2rem;
  }

  dt {
    background-color: ${themeGet('color.4')};
    color: #000;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-size: 0.7rem;
    padding: 5px 5px 3px;
    display: inline-block;
    min-width: 110px;
    font-family: ${themeGet('fonts.mono')};
    font-weight: 700;
    line-height: 1em;
    margin-bottom: 0.5em;
  }

  dd {
    color: ${themeGet('color.4')};
    font-family: ${themeGet('fonts.mono')};
  }
`;
